export const container = `
  bg-ll-surface p-3
  rounded-md h-full box-border
  text-ll-on-background
`;

export const values = `
  w-full h-[calc(100%-32px)]
  flex flex-col align-middle justify-center
  box-border
`;

export const item = `
  w-full
  flex items-center
  mb-1 last:mb-0 lg:mb-2
  data-[is-single="false"]:flex-row
  data-[is-single="false"]:justify-between
  data-[is-single="true"]:flex-col
  data-[is-single="true"]:justify-center
  `;

export const valueLabel = `
  flex items-center justify-center
`;

export const icon = `
  fill-black
`;

export const multipleItemLabel = `
  text-sm
`;

export const singleItemText = `
  font-normal  text-ll-font-size-h2
`;
export const multipleItemText = `
  font-normal
`;
export const title = `
  font-normal
  text-ll-font-size-p
`;
